import { render, staticRenderFns } from "./sendCard.vue?vue&type=template&id=3c57662c&scoped=true"
import script from "./sendCard.vue?vue&type=script&lang=js"
export * from "./sendCard.vue?vue&type=script&lang=js"
import style0 from "./sendCard.vue?vue&type=style&index=0&id=3c57662c&prod&lang=less&scoped=true"
import style1 from "./sendCard.vue?vue&type=style&index=1&id=3c57662c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c57662c",
  null
  
)

export default component.exports